/**
 * Environment detection utilities
 */

export const isDevelopment = () => {
  return import.meta.env.DEV || window.location.hostname === 'localhost' || window.location.hostname.includes('127.0.0.1');
};

export const isProduction = () => {
  return import.meta.env.PROD && window.location.hostname === 'rocketcitynerd.com';
};

export const isLocalhost = () => {
  return window.location.hostname === 'localhost' || window.location.hostname.includes('127.0.0.1');
};

export const getCurrentDomain = () => {
  return window.location.hostname;
};

export const shouldLoadAnalytics = () => {
  return isProduction();
};

export const shouldRegisterServiceWorker = () => {
  // Temporary: disable SW in production to eliminate stale chunk mismatches.
  // You can re-enable by toggling this back once caches/CDN are fully purged and stable.
  const enableDev = import.meta.env.VITE_ENABLE_SW_DEV === 'true';
  if (isProduction()) return false;
  return enableDev && isLocalhost();
};
